module.exports = __webpack_public_path__ + "static/media/2504208.SteamPost_Resource3_1600x240.ea94cf50.png";